/**
 * Header height token.
 *
 * Measures the rendered header stack (announcement bar + header) as the offset
 * from the document top to #MainContent and exposes it as --header-height on
 * :root. The DS token defaults to 0px (snippets/ds--primitives--tokens.liquid);
 * consumers: --viewport-height, mega menu panel max-height, below-header
 * drawers, predictive search.
 *
 * A ResizeObserver on every element preceding #MainContent keeps the value
 * live: dismissing the announcement bar or crossing a breakpoint re-measures.
 * The header must remain in normal flow (static/sticky) — a position:fixed
 * header would collapse the offset to 0.
 */
(() => {
	const main = document.getElementById('MainContent');
	if (!main) return;

	let last = null;
	const update = () => {
		const top = Math.max(0, Math.round(main.getBoundingClientRect().top + window.scrollY));
		if (top === last) return;
		last = top;
		document.documentElement.style.setProperty('--header-height', top + 'px');
	};

	const observer = new ResizeObserver(update);
	for (let el = main.previousElementSibling; el; el = el.previousElementSibling) {
		observer.observe(el);
	}
	update();
})();
